import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UrlSerializer } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { SearchPagingComponent } from './components/base-search/search-paging/search-paging.component';
import { LoaderComponent } from './components/loader/loader.component';
import { NgbdModalContentComponent } from './components/ngb-modal-content-component/ngb-modal-content.component';
import { JsonQueryParamsDirective } from './directives/json-query-params.directive';
import { JsonQueryParamsUrlSerializer } from './internals/json-query-param-url-serializer';
import { StringArrayToDisplayValue } from './pipes/string-array-to-display-value.pipe';
import { ApiHttpClient } from './services/api-http-client';
import { ApiHttpClientNotificationService, DefaultApiHttpClientNotificationService } from './services/api-http-client-notification.service';
import { BaseComponentContext } from './services/base-component-context.service';
import { BroadcastService } from './services/broadcast.service';
import { NavigationService } from './services/navigation.service';
import { NotificationsService } from './services/notification.service';
import { WafModal } from './services/waf-modal';



const PUBLIC_COMPONENTS = [
      LoaderComponent,
      NgbdModalContentComponent,
      SearchPagingComponent
];

const PUBLIC_DIRECTIVES = [
      JsonQueryParamsDirective
];

const pipes = [
      StringArrayToDisplayValue
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ToastrModule,
    NgbModalModule
  ],
  declarations: [
    PUBLIC_DIRECTIVES,
    pipes,
    PUBLIC_COMPONENTS,
  ],
  providers: [
    ApiHttpClient,
    BaseComponentContext,
    WafModal
  ],
  exports: [
    pipes,
    PUBLIC_COMPONENTS,
    PUBLIC_DIRECTIVES
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TCMCoreModule {
      static forRoot(): ModuleWithProviders<TCMCoreModule> {
        return {
          ngModule: TCMCoreModule,
          providers: [
            ApiHttpClient,
            BroadcastService,        
            NavigationService,
            NotificationsService,
            { provide: ApiHttpClientNotificationService, useClass: DefaultApiHttpClientNotificationService },
            { provide: UrlSerializer, useClass: JsonQueryParamsUrlSerializer }
          ]
    }
  }
}
